<template>
  <div data-component-group="filter-forms" data-component="pins">
    <FiltersForm
        has-phone-sheet
        :applied-filters="appliedFilters"
        :on-clear-filter="clearFilter"
        :has-filters="hasFilters"
        @filter="onFilter"
        @clear="onClearFilters"
        v-model="selectedCountries"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips, { platformChips } from '@/mixins/filterChips';

  // TODO: Translate component

  export default {
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        selectedCountries: [],
      };
    },
    computed: {
      filterChipFields() {
        const platforms = this.$store.getters['users/countries'] || [];

        return [
          {
            model: 'selectedCountries',
            label: this.$t('platform'),
            toChips: platformChips(platforms),
          },
        ];
      },
      hasFilters() {
        return this.selectedCountries.length > 0;
      },
    },
    methods: {
      onFilter() {
        const {selectedCountries} = this;

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();

        this.$emit('filter', {
          countries: selectedCountries,
        });
      },
      onClearFilters() {
        this.selectedCountries = [];

        this.clearFiltersUrl();
        this.forgetAppliedFilters();

        this.$emit('clearFilters');
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='filter-forms'][data-component='pins'] {
  .v-btn {
    height: auto;
    max-height: initial;
    white-space: normal;
    padding: $spacing-xs;

    .v-btn__content {
      justify-content: flex-start;
    }

    &.active {
      color: map.get($colors, shades, 'white');
      background-color: map.get($colors, grey, base) !important;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
